import { Box, Typography } from "@mui/material";
import { BookingStatus } from "src/constants/booking";

export const CustomStatusCell = ({ params }: any) => {
  switch (params.row.status) {
    case BookingStatus.approved:
      return (
        <Box
          sx={{
            display: "flex",
          }}
        >
          <Typography
            sx={{
              backgroundColor: "#E1FFE4",
              color: "#23A26D",
              padding: "2px 8px",
              borderRadius: "6px",
              "&:nth-of-type(2n)": {
                marginLeft: "4px",
              },
            }}
          >
            {params.row.status}
          </Typography>
          <Typography
            sx={{
              color: `#1F6AD4`,
              padding: "0 8px",
              backgroundColor: params.row.payed ? `#E3EFFF` : "Not paid",
              border: `1px solid #89BAFF`,
              borderRadius: "6px",
              "&:nth-of-type(2n)": {
                marginLeft: "4px",
              },
            }}
          >
            {params.row.payed ? "Paid" : "Not paid"}
          </Typography>
        </Box>
      );
    case BookingStatus.cancelled:
      return (
        <Typography
          sx={{
            backgroundColor: "#FFE6E8",
            color: "#D62F39",
            padding: "2px 8px",
            borderRadius: "6px",
            "&:nth-of-type(2n)": {
              marginLeft: "4px",
            },
          }}
        >
          Cancelled by client
        </Typography>
      );
    case BookingStatus.removed_by_admin:
      return (
        <Typography
          sx={{
            backgroundColor: "#FFEEDF",
            color: "#E46D00",
            padding: "2px 8px",
            borderRadius: "6px",
            "&:nth-of-type(2n)": {
              marginLeft: "4px",
            },
          }}
        >
          Deleted by admin
        </Typography>
      );
    default:
      return (
        <Typography
          sx={{
            backgroundColor: "#F3F3F3",
            color: "#676767",
            padding: "2px 8px",
            borderRadius: "6px",
            "&:nth-of-type(2n)": {
              marginLeft: "4px",
            },
          }}
        >
          Completed
        </Typography>
      );
  }
};